<template lang="pug">
	.networks(v-if="Version.SelectedVersion" v-bar :style="{height: (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') ? '350px' : '215px'}")
		.networks-content(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card'")
			.dropdown-item(v-for="release in releases" @click.stop="setNetwork(release.codename)" v-if="release.type === 'playable' && isReleaseAvailable(release)")
				.item-title {{release.title}}
					.icon.fa.fa-spinner.fa-spin(v-if="isInProcess(release.codename)")
					.error(v-if="getProcessError(release.codename)") {{getProcessError(release.codename)}}
				.item-icon(:style="{backgroundImage: `url(/Images/Icons/Networks/${release.options['icon'] || release.codename}.png)`, width: release.options['iconWidth']}")
				.item-description.text-muted {{release.description}}
				.multiple-select-checkmark-wrapper(v-if="(scope === 'download' || scope === 'upload')")
					.checkbox-background
						i.fa.fa-check(v-show="isReleaseSelected(release)")

		.networks-content(v-if="Project.SelectedProject.type === 'banner'")
			.dropdown-item(v-for="release in releases" @click="setNetwork(release.codename)" v-if="release.type === 'banner' && isReleaseAvailable(release)")
				.item-title {{release.title}}
					.icon.fa.fa-spinner.fa-spin(v-if="isInProcess(release.codename)")
					.error(v-if="getProcessError(release.codename)") {{getProcessError(release.codename)}}
				.item-icon(:style="{backgroundImage: `url(/Images/Icons/Networks/${release.options['icon'] || release.codename}.png)`, width: release.options['iconWidth']}")
				.item-description.text-muted {{release.description}}
		//.networks-content
			.dropdown-item(v-for="release in availableReleases" @click="setNetwork(release.codename)")
				.item-title {{release.title}}
					.icon.fa.fa-spinner.fa-spin(v-if="isInProcess(release.codename)")
					.error(v-if="getProcessError(release.codename)") {{getProcessError(release.codename)}}
				.item-icon(:style="{backgroundImage: `url(/Images/Icons/Networks/${release.options['icon'] || release.codename}.png)`, width: release.options['iconWidth']}")
				.item-description.text-muted {{release.description}}
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Metadata } 		from './../../services/Metadata'
	import { Publisher } 		from '../../services/Publisher'
	import { Project } 			from '../../services/Project'
	import { Version } 			from '../../services/Version'
	import { Asset } 			from '../../services/Asset'
	import { Monitoring } 		from '../../services/Monitoring'
	import { User } 			from "../../services/User"

	export default {
		name: "NetworkList",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Publisher Changed", "Selected Publisher Data Changed", "Selected Version Changed", "Metadata Loaded", "Active Processes Changed:release-build", "Project Fully Loaded"]
		},
		props: ['callback', 'scope', 'multipleAllowed', 'network'],
		data() {

			this.Publisher = Publisher;
			this.Project = Project;
			this.Version = Version;
			this.Asset = Asset;
			this.Monitoring = Monitoring;

			this.releases = [];
			this.availableReleases = [];

			return {
				showed: true,
				releaseType: ''
			};

		},
		methods: {
			collectData() {

				this.releases = _.orderBy(_.values(Metadata.Releases), 'priority');
				this.availableReleases = this.releases.filter(release => this.isReleaseAvailable(release));

				if (this.scope === 'upload' && !this.multipleAllowed) this.setNetwork(this.availableReleases[0].codename);

			},
			setNetwork(name) {

				if (this.multipleAllowed) {

					if (this.scope === 'download') {

						let selectedReleases = User.currentUser.options.features.multipleDownloadNetworks || {};
						if (selectedReleases[name]) delete selectedReleases[name];
						else selectedReleases[name] = true;
						User.currentUser.options.features.multipleDownloadNetworks = selectedReleases;
						User.toggleFeature(User.currentUser.id, 'multipleDownloadNetworks', selectedReleases);

						Broadcast.call('Multiple Download Networks Changed', [Object.keys(selectedReleases || {}).length]);

					} else if (this.scope === 'upload' && this.network === 'mraid') {

						let selectedReleases = User.currentUser.options.features.multipleUploadMraidioNetworks || {};
						if (selectedReleases[name]) delete selectedReleases[name];
						else selectedReleases[name] = true;
						User.currentUser.options.features.multipleUploadMraidioNetworks = selectedReleases;
						User.toggleFeature(User.currentUser.id, 'multipleUploadMraidioNetworks', selectedReleases);

						Broadcast.call('Multiple Upload Mraidio Networks Changed', [Object.keys(selectedReleases || {}).length]);

					} else if (this.scope === 'upload' && this.network === 'amazons3') {

						let selectedReleases = User.currentUser.options.features.multipleUploadAmazonS3Networks || {};
						if (selectedReleases[name]) delete selectedReleases[name];
						else selectedReleases[name] = true;
						User.currentUser.options.features.multipleUploadAmazonS3Networks = selectedReleases;
						User.toggleFeature(User.currentUser.id, 'multipleUploadAmazonS3Networks', selectedReleases);

						Broadcast.call('Multiple Upload Amazon S3 Networks Changed', [Object.keys(selectedReleases || {}).length]);

					}

					this.$forceUpdate()

					return;

				}

				this.callback(name);

			},
			isReleaseAvailable(release) {

				if (!release['enabled']) return false;

				if (!release.options['scope'].includes(this.scope)) return false;

				if (this.multipleAllowed && this.scope === 'download' && release.codename === 'sky-kids') return false;

				if (release.codename in (Publisher.SelectedPublisher.options['Releases'] || {})) return Publisher.SelectedPublisher.options['Releases'][release.codename];

				if (release.type === 'playable' && Project.SelectedProject?.type !== 'playable' && Project.SelectedProject?.type !== 'end-card') return false;
				if (release.type === 'banner' && Project.SelectedProject?.type !== 'banner') return false;

				return release.options["enabledByDefault"];

			},

			isReleaseSelected(release) {

				if (!this.multipleAllowed) return false;

				if (!User.currentUser || !User.currentUser.options || !User.currentUser.options.features) return;

				if (this.scope === 'download') {

					return User.currentUser.options.features.multipleDownloadNetworks && User.currentUser.options.features.multipleDownloadNetworks[release.codename];

				} else if (this.scope === 'upload' && this.network === 'mraid') {

					return User.currentUser.options.features.multipleUploadMraidioNetworks && User.currentUser.options.features.multipleUploadMraidioNetworks[release.codename];

				} else if (this.scope === 'upload' && this.network === 'amazons3') {

					return User.currentUser.options.features.multipleUploadAmazonS3Networks && User.currentUser.options.features.multipleUploadAmazonS3Networks[release.codename];

				}

				return false;
			},

			isInProcess(releaseType) {

				return this.scope === 'download' && Monitoring.activeProcesses['release-build'][`${Version.SelectedVersion.id}-${releaseType}`]

			},
			getProcessError(releaseType) {

				if (this.scope === 'download' && Monitoring.activeProcessesErrors['release-build'][`${Version.SelectedVersion.id}-${releaseType}`]) {

					let process = Monitoring.activeProcessesErrors['release-build'][`${Version.SelectedVersion.id}-${releaseType}`];

					if (process.error?.type === 'asset-compress') return `Asset failed: ${process.error.assetCodename}`;
					else return `Unknown error`;

				} else {

					return false;

				}

			}
		}
	}
</script>

<style lang="sass">

	.networks
		overflow-x: hidden
		overflow-y: auto

		.dropdown-item
			white-space: normal
			padding: 0px 20px 10px 20px
			width: 250px

			>.multiple-select-checkmark-wrapper
				display: none

			.item-title
				margin-bottom: 5px
				padding-top: 5px
				display: flex
				flex-direction: row
				align-items: center
				white-space: nowrap

				.icon
					margin-left: 10px

				.error
					font-size: 0.7rem
					margin-left: 5px
					color: #f86c6b

			.item-description
				white-space: normal
				line-height: 12px
				font-size: 0.6rem
				width: 66%

			.item-icon
				position: absolute
				bottom: 5px
				right: 10px
				width: calc(37% - 10px)
				height: 44px
				opacity: 1
				background-size: contain
				background-repeat: no-repeat
				background-position: right center
				max-height: 55px
				font-size: 30px

	.networks::-webkit-scrollbar
		width: 10px
		margin-left: -10px
		-webkit-appearance: none
		appearance: none

	.networks::-webkit-scrollbar-track
		background-color: rgba(255,255,255,0.3)
		border-right: 1px solid #f2f2f2
		border-left: 1px solid #f2f2f2

	.networks::-webkit-scrollbar-thumb
		height: 50px
		background-color: rgba(255,255,255,0.2)
		background-clip: content-box
		border-color: transparent
		border-style: solid
		border-width: 1px 2px


	.download-button > .dropdown-menu.multiple-download > .networks, .dropdown-menu.multiple-upload > .networks

		.networks-content

			.dropdown-item

				>.multiple-select-checkmark-wrapper
					left: 0
					top: 0
					position: absolute
					width: 30px
					height: 100%
					display: flex
					justify-content: center
					margin-top: 8px

					.checkbox-background
						width: 17px
						height: 17px
						border: 1px solid #23282c
						background-color: #515b65
						border-radius: 0.2rem
						position: relative

						>i.fa.fa-check
							position: absolute
							left: 8px
							top: 1px
							font-size: 13px

</style>

